import {
    DateRange,
    IQueryString,
    objToQueryString
} from '../../../shared/models';
import * as moment from 'moment';

export class TransferHistoryFilter implements IQueryString {

    constructor(public date?: DateRange) {}

    toQueryString() {
        let start = this.date ? moment(this.date.start).startOf('day') : null;
        let end = this.date ? moment(this.date.end).endOf('day') : null;

        let payload = {
            'sent[start]': start ? start.format('MM/DD/YYYY HH:mm:ss') : '',
            'sent[end]': end ? end.format('MM/DD/YYYY HH:mm:ss') : '',
        };

        return objToQueryString(payload);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/transfer-history-filter.ts